import accordionImgUrl from '../../../images/portfolio/web-images/react/accordion.jpg';
import birthdayReminderImgUrl from '../../../images/portfolio/web-images/react/birthday-reminder.jpg';
import businessCardImgUrl from '../../../images/portfolio/web-images/react/business-card.jpg';
import colorGeneratorImgUrl from '../../../images/portfolio/web-images/react/color-generator.jpg';
import githubAccountInfoImgUrl from '../../../images/portfolio/web-images/react/github-account-info.jpg';
import githubFollowersPaginationImgUrl from '../../../images/portfolio/web-images/react/github-followers-pagination.jpg';
import hackerNewsPaginationImgUrl from '../../../images/portfolio/web-images/react/hacker-news-pagination.jpg';
import lightDarkModeImgUrl from '../../../images/portfolio/web-images/react/light-dark-mode.jpg';
import markdownPreviewImgUrl from '../../../images/portfolio/web-images/react/markdown-preview.jpg';
import mealsSliderImgUrl from '../../../images/portfolio/web-images/react/meals-slider.jpg';
import modalImgUrl from '../../../images/portfolio/web-images/react/modal.jpg';
import navbarSidebarImgUrl from '../../../images/portfolio/web-images/react/navbar-sidebar.jpg';
import navbarImgUrl from '../../../images/portfolio/web-images/react/navbar.jpg';
import ourReviewsImgUrl from '../../../images/portfolio/web-images/react/our-reviews.jpg';
import photoGalleryImgUrl from '../../../images/portfolio/web-images/react/photo-gallery.jpg';
import restaurantMenuImgUrl from '../../../images/portfolio/web-images/react/restaurant-menu.jpg';
import shoppingCartImgUrl from '../../../images/portfolio/web-images/react/shopping-cart.jpg';
import textGeneratorImgUrl from '../../../images/portfolio/web-images/react/text-generator.jpg';
import todoListImgUrl from '../../../images/portfolio/web-images/react/todo-list.jpg';
import toursPlansImgUrl from '../../../images/portfolio/web-images/react/tours-plans.jpg';
import workExperienceImgUrl from '../../../images/portfolio/web-images/react/work-experience.jpg';
import asaWebsiteImgUrl from '../../../images/portfolio/web-images/react/amr-saad-abdallah-website.jpg';
import movflixWebsiteImgUrl from '../../../images/portfolio/web-images/react/movflix.jpg';
import emarketingWebsiteImgUrl from '../../../images/portfolio/web-images/react/e-marketing.jpg';

const reactTemplateList = [
	{
		imgUrl: asaWebsiteImgUrl,
		title: 'My Website',
		githubUrl: 'https://github.com/amrsaadabdallah/my-website',
		infoUrl: 'https://github.com/amrsaadabdallah/amrsaadabdallah.github.io',
		liveUrl: 'https://amrsaadabdallah.github.io',
		type: 'small',
	},
	{
		imgUrl: emarketingWebsiteImgUrl,
		title: 'E-Marketing',
		githubUrl: 'https://github.com/amrsaadabdallah/my-e-marketing-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/e-marketing-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/e-marketing-react-app',
		type: 'large',
	},
	{
		imgUrl: movflixWebsiteImgUrl,
		title: 'Movflix',
		githubUrl: 'https://github.com/amrsaadabdallah/my-movflix-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/movflix-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/movflix-react-app',
		type: 'large',
	},
	{
		imgUrl: githubAccountInfoImgUrl,
		title: 'Github Account Info',
		githubUrl:
			'https://github.com/amrsaadabdallah/my-github-account-info-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/github-account-info-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/github-account-info-react-app',
		type: 'large',
	},
	{
		imgUrl: photoGalleryImgUrl,
		title: 'Photo Gallery',
		githubUrl: 'https://github.com/amrsaadabdallah/my-photo-gallery-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/photo-gallery-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/photo-gallery-react-app',
		type: 'small',
	},
	{
		imgUrl: hackerNewsPaginationImgUrl,
		title: 'Hacker News Pagination',
		githubUrl:
			'https://github.com/amrsaadabdallah/my-hacker-news-pagination-react-app',
		infoUrl:
			'https://github.com/amrsaadabdallah/hacker-news-pagination-react-app',
		liveUrl:
			'https://amrsaadabdallah.github.io/hacker-news-pagination-react-app',
		type: 'large',
	},
	{
		imgUrl: githubFollowersPaginationImgUrl,
		title: 'Github Followers Pagination',
		githubUrl:
			'https://github.com/amrsaadabdallah/my-github-followers-pagination-react-app',
		infoUrl:
			'https://github.com/amrsaadabdallah/github-followers-pagination-react-app',
		liveUrl:
			'https://amrsaadabdallah.github.io/github-followers-pagination-react-app',
		type: 'small',
	},
	{
		imgUrl: markdownPreviewImgUrl,
		title: 'Markdown Preview',
		githubUrl:
			'https://github.com/amrsaadabdallah/my-markdown-preview-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/markdown-preview-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/markdown-preview-react-app',
		type: 'small',
	},
	{
		imgUrl: shoppingCartImgUrl,
		title: 'Shopping Cart',
		githubUrl: 'https://github.com/amrsaadabdallah/my-shopping-cart-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/shopping-cart-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/shopping-cart-react-app',
		type: 'small',
	},
	{
		imgUrl: todoListImgUrl,
		title: 'To-Do List',
		githubUrl: 'https://github.com/amrsaadabdallah/my-todo-list-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/todo-list-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/todo-list-react-app',
		type: 'small',
	},
	{
		imgUrl: colorGeneratorImgUrl,
		title: 'Colors Generator',
		githubUrl:
			'https://github.com/amrsaadabdallah/my-color-generator-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/color-generator-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/color-generator-react-app',
		type: 'small',
	},

	{
		imgUrl: lightDarkModeImgUrl,
		title: 'Light & Dark Mode',
		githubUrl:
			'https://github.com/amrsaadabdallah/my-light-dark-mode-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/light-dark-mode-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/light-dark-mode-react-app',
		type: 'small',
	},
	{
		imgUrl: businessCardImgUrl,
		title: 'Business Card',
		githubUrl: 'https://github.com/amrsaadabdallah/my-business-card-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/business-card-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/business-card-react-app',
		type: 'small',
	},
	{
		imgUrl: restaurantMenuImgUrl,
		title: 'Restaurant Menu',
		githubUrl:
			'https://github.com/amrsaadabdallah/my-restaurant-menu-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/restaurant-menu-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/restaurant-menu-react-app',
		type: 'small',
	},

	{
		imgUrl: textGeneratorImgUrl,
		title: 'Text Generator',
		githubUrl: 'https://github.com/amrsaadabdallah/my-text-generator-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/text-generator-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/text-generator-react-app',
		type: 'small',
	},
	{
		imgUrl: accordionImgUrl,
		title: 'Accordion',
		githubUrl: 'https://github.com/amrsaadabdallah/my-accordion-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/accordion-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/accordion-react-app',
		type: 'small',
	},
	{
		imgUrl: workExperienceImgUrl,
		title: 'Work Experience',
		githubUrl:
			'https://github.com/amrsaadabdallah/my-work-experience-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/work-experience-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/work-experience-react-app',
		type: 'small',
	},
	{
		imgUrl: ourReviewsImgUrl,
		title: 'Our Reviews',
		githubUrl: 'https://github.com/amrsaadabdallah/my-our-reviews-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/our-reviews-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/our-reviews-react-app',
		type: 'small',
	},
	{
		imgUrl: toursPlansImgUrl,
		title: 'Tours Plans',
		githubUrl: 'https://github.com/amrsaadabdallah/my-tours-plans-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/tours-plans-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/tours-plans-react-app',
		type: 'small',
	},
	{
		imgUrl: navbarSidebarImgUrl,
		title: 'Navbar & Sidebar',
		githubUrl: 'https://github.com/amrsaadabdallah/my-navbar-sidebar-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/navbar-sidebar-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/navbar-sidebar-react-app',
		type: 'small',
	},
	{
		imgUrl: navbarImgUrl,
		title: 'Navbar Component',
		githubUrl: 'https://github.com/amrsaadabdallah/my-navbar-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/navbar-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/navbar-react-app',
		type: 'small',
	},
	{
		imgUrl: birthdayReminderImgUrl,
		title: 'Birthday Reminder',
		githubUrl:
			'https://github.com/amrsaadabdallah/my-birthday-reminder-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/birthday-reminder-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/birthday-reminder-react-app',
		type: 'small',
	},

	{
		imgUrl: mealsSliderImgUrl,
		title: 'Meals Slider',
		githubUrl: 'https://github.com/amrsaadabdallah/my-meals-slider-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/meals-slider-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/meals-slider-react-app',
		type: 'small',
	},
	{
		imgUrl: modalImgUrl,
		title: 'Modal Component',
		githubUrl: 'https://github.com/amrsaadabdallah/my-modal-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/modal-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/modal-react-app',
		type: 'small',
	},
];

export default reactTemplateList;
